export var Modals;

(function (Modals) {
  Modals["Error"] = "Error";
  Modals["AddNewUser"] = "AddNewUser";
  Modals["AddNewWisperUser"] = "AddNewWisperUser";
  Modals["AddNewGroup"] = "AddNewGroup";
  Modals["AddUsersWithFile"] = "AddUsersWithFile";
  Modals["UsersConflicts"] = "UsersConflicts";
})(Modals || (Modals = {}));